const resizeHandler = Symbol('resize')
function wrap($el, offset) {
  return () => {
    const ch = window.innerHeight
    const mainH = ch - offset // 60 - header 高度

    $el.style.minHeight = mainH + 'px'
  }
}

export default {
  install(Vue) {
    Vue.directive('auto-height', {
      bind($el, binding) {
        const handler = wrap($el, binding.value || 0)
        $el[resizeHandler] = handler

        window.addEventListener('resize', handler)
      },
      inserted($el, binding, vnode) {
        const handler = wrap($el, binding.value || 0)
        handler()
      },
      unbind($el) {
        window.removeEventListener('resize', $el[resizeHandler])
        $el[resizeHandler] = null
      }
    })
  },

}
